import { FormFooterAction } from '../../../../shared/components/FormActionsContext';
import React from 'react';
import { Plus, Trash2 } from '../../../../shared/assets/AppIcons';
import { Button } from '@/shared/ui/button';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';

export default function TranchesFieldArray({ rows, onAdd, onRemove, onChange }) {
  return (
    <div className="bg-[var(--warning-soft)] p-4 rounded-lg border border-[var(--warning-border)]">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-[var(--warning-text)]">Tranche</h3>
        <FormFooterAction>
          <Button
            type="button"
            className="form-footer-add"
            aria-label="Aggiungi tranche"
            title="Aggiungi tranche"
            size="sm"
            variant="outline"
            onClick={onAdd}
          >
            <Plus size={16} className="mr-1" />
            Aggiungi Tranche
          </Button>
        </FormFooterAction>
      </div>
      <div className="space-y-3">
        {rows.map((row, index) => (
          <div
            key={row.id}
            className="bg-[var(--surface-raised)] p-3 rounded-lg border border-[var(--warning-border)]"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-medium text-[var(--warning-text)]">Tranche #{index + 1}</span>
              {rows.length > 1 ? (
                <Button
                  type="button"
                  size="sm"
                  variant="ghost"
                  onClick={() => onRemove(row.id)}
                  className="h-6 w-6 p-0 text-[var(--warning-text)]"
                >
                  <Trash2 size={16} />
                </Button>
              ) : null}
            </div>
            <div className="grid grid-cols-4 gap-2">
              <div>
                <Label className="text-xs">Percentuale</Label>
                <Input
                  value={row.percentuale}
                  onChange={(event) => onChange(row.id, 'percentuale', event.target.value)}
                  className="mt-1 h-8 text-xs"
                />
              </div>
              <div>
                <Label className="text-xs">Importo</Label>
                <Input
                  value={row.importo}
                  onChange={(event) => onChange(row.id, 'importo', event.target.value)}
                  className="mt-1 h-8 text-xs"
                />
              </div>
              <div>
                <Label className="text-xs">Data Scadenza</Label>
                <Input
                  value={row.dataScadenza}
                  onChange={(event) => onChange(row.id, 'dataScadenza', event.target.value)}
                  className="mt-1 h-8 text-xs"
                />
              </div>
              <div>
                <Label className="text-xs">Condizione</Label>
                <Input
                  value={row.condizione}
                  onChange={(event) => onChange(row.id, 'condizione', event.target.value)}
                  className="mt-1 h-8 text-xs"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
